import BaseForm, { Field } from "../ContactForm/BaseForm"
import styles from "../ContactForm/ContactForm.module.scss"

const VmaForm = ({ data, content }) => (
  <BaseForm
    data={data}
    content={content}
    formId="vmaForm"
    action={`${process.env.NEXT_PUBLIC_API_URL}/!/forms/vma-formular/`}
    submitLabel="Unverbindlich Anfragen"
  >
    <Field id="interest" label="Ich habe Interesse an *">
      <select
        required
        id="interest"
        name="interest"
        defaultValue=""
        className={styles.inputFields}
      >
        <option value="" disabled>
          Bitte wählen
        </option>
        <option value="basis">Basis-Paket</option>
        <option value="premium">Premium-Paket</option>
      </select>
    </Field>
  </BaseForm>
)

export default VmaForm
